export default {"src":"/_next/static/media/Promotion.87676722.svg","height":85,"width":84,"blurWidth":0,"blurHeight":0};